import { createReducer } from 'redux-act';

import * as actions from '../actions/zipCode';

const DEFAULT_STATE = {
  validationEnabled: null,
  attemptsAllowed: 0,
  attemptsLeft: 0,
  status: null,
  path: null,
};

export default createReducer(
  {
    [actions.setZipCodeInfo]: (
      state,
      { status, attemptsAllowed, attemptsLeft, path }
    ) => ({
      ...state,
      status: status || null,
      attemptsAllowed,
      attemptsLeft,
      path,
    }),
    [actions.setZipCodeDecisions]: (state, decisions) => ({
      ...state,
      validationEnabled: decisions['troy.feature.allow.zipcode.validation'],
    }),
    [actions.setValidationFlag]: (state, value) => ({
      ...state,
      validationEnabled: value,
    }),
    [actions.zipCodeReset]: () => ({ ...DEFAULT_STATE }),
  },
  DEFAULT_STATE
);
